// ErrorBoundary.tsx — VoiceSpectrum.Web.T2 · v10.0.14.2 · 2026-05-21 · VoiceSpectrum AI
// v10.0.14.2 HOTFIX: prevents blank-page on render errors (D17).
import React from 'react';

interface State { hasError: boolean; error?: Error; }

export default class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('[T2 ErrorBoundary]', error, info);
  }

  handleReset = () => this.setState({ hasError: false, error: undefined });

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '2rem',
          margin: '2rem auto',
          maxWidth: 640,
          background: '#fef2f2',
          border: '1px solid #fecaca',
          borderRadius: 8,
          color: '#1a1530',
        }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#b91c1c', marginBottom: 8 }}>
            Something went wrong
          </div>
          <div style={{ fontSize: 13, color: '#5b5777', marginBottom: 12 }}>
            The page encountered an error and could not render. Please refresh or contact support if the issue persists.
          </div>
          {this.state.error?.message && (
            <pre style={{
              background: '#fff',
              border: '1px solid #fecaca',
              borderRadius: 6,
              padding: 12,
              fontSize: 11.5,
              color: '#b91c1c',
              overflow: 'auto',
              marginBottom: 12,
            }}>{this.state.error.message}</pre>
          )}
          <button
            onClick={this.handleReset}
            style={{
              padding: '6px 14px',
              borderRadius: 6,
              border: '1px solid #6d28d9',
              background: '#6d28d9',
              color: '#fff',
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >Try again</button>
        </div>
      );
    }
    return this.props.children;
  }
}

// VoiceSpectrum.Web.T2 · v10.0.14.2 · 2026-05-21 · VoiceSpectrum AI
